export function sampleAsset(filename: string) {
  const fallback = `/assets/${filename}`;
  if (typeof window === 'undefined') return fallback;
  const legacyPrefix = ['PAW', 'BOND'].join('');
  const legacyAssets = window[`${legacyPrefix}_ASSETS`] as Record<string, string> | undefined;
  return window.PORTRAIT_ASSETS?.[filename] || legacyAssets?.[filename] || fallback;
}

export const moodOptions = [
  {
    id: 'deep-burgundy',
    label: 'Walnut Warmth',
    image: sampleAsset('soulpaw-Step_1_Button_1.jpg')
  },
  {
    id: 'warm-beige',
    label: 'Cream Serenity',
    image: sampleAsset('soulpaw-Step_1_Button_3.jpg')
  },
  {
    id: 'charcoal-gray',
    label: 'Ash Elegance',
    image: sampleAsset('soulpaw-Step_1_Button_4.jpg')
  },
  {
    id: 'classic-mono',
    label: 'Classic Monochrome',
    image: sampleAsset('soulpaw-Step_1_Button_2.jpg')
  }
];

interface CountOption {
  count: 1 | 2;
  label: string;
  imageByMood: string[];
}

export const personCountOptions: CountOption[] = [
  {
    count: 1,
    label: '1 Person',
    imageByMood: [
      sampleAsset('soulpaw-Step_2_Button_1_step_1_1.jpg'),
      sampleAsset('soulpaw-Step_2_Button_1_step_1_2.jpg'),
      sampleAsset('soulpaw-Step_2_Button_1_step_1_3.jpg'),
      sampleAsset('soulpaw-Step_2_Button_1_step_1_4.jpg')
    ]
  },
  {
    count: 2,
    label: '2 Person',
    imageByMood: [
      sampleAsset('soulpaw-Step_2_Button_2_step_1_1.jpg'),
      sampleAsset('soulpaw-Step_2_Button_2_step_1_2.jpg'),
      sampleAsset('soulpaw-Step_2_Button_2_step_1_3.jpg'),
      sampleAsset('soulpaw-Step_2_Button_2_step_1_4.jpg')
    ]
  }
];

export const petCountOptionsByPeople: Record<number, CountOption[]> = {
  1: [
    {
      count: 1,
      label: '1 Pet',
      imageByMood: [
        sampleAsset('soulpaw-Step_3_1_Person_Button_1_step_1_1.jpg'),
        sampleAsset('soulpaw-Step_3_1_Person_Button_1_step_1_2.jpg'),
        sampleAsset('soulpaw-Step_3_1_Person_Button_1_step_1_3.jpg'),
        sampleAsset('soulpaw-Step_3_1_Person_Button_1_step_1_4.jpg')
      ]
    },
    {
      count: 2,
      label: '2 Pet',
      imageByMood: [
        sampleAsset('soulpaw-Step_3_1_Person_Button_2_step_1_1.jpg'),
        sampleAsset('soulpaw-Step_3_1_Person_Button_2_step_1_2.jpg'),
        sampleAsset('soulpaw-Step_3_1_Person_Button_2_step_1_3.jpg'),
        sampleAsset('soulpaw-Step_3_1_Person_Button_2_step_1_4.jpg')
      ]
    }
  ],
  2: [
    {
      count: 1,
      label: '1 Pet',
      imageByMood: [
        sampleAsset('soulpaw-Step_3_2_Person_Button_1_step_1_1.jpg'),
        sampleAsset('soulpaw-Step_3_2_Person_Button_1_step_1_2.jpg'),
        sampleAsset('soulpaw-Step_3_2_Person_Button_1_step_1_3.jpg'),
        sampleAsset('soulpaw-Step_3_2_Person_Button_1_step_1_4.jpg')
      ]
    },
    {
      count: 2,
      label: '2 Pet',
      imageByMood: [
        sampleAsset('soulpaw-Step_3_2_Person_Button_2_step_1_1.jpg'),
        sampleAsset('soulpaw-Step_3_2_Person_Button_2_step_1_2.jpg'),
        sampleAsset('soulpaw-Step_3_2_Person_Button_2_step_1_3.jpg'),
        sampleAsset('soulpaw-Step_3_2_Person_Button_2_step_1_4.jpg')
      ]
    }
  ]
};

export interface ClothingOption {
  id: string;
  label: string;
  description: string;
  image: string;
}

const clothingImage = (name: string) => sampleAsset(name);

export const clothingOptionsByMood: Record<string, ClothingOption[]> = {
  'warm-beige': [
    {
      id: 'studio-outfit',
      label: 'Studio Outfit',
      description: '(basic plain sweater)',
      image: clothingImage('mix-button_1.2.png')
    },
    {
      id: 'own-outfit',
      label: 'Your Own Outfit',
      description: '(based on your photo)',
      image: clothingImage('mix-button_1.1.png')
    }
  ],
  'charcoal-gray': [
    {
      id: 'studio-outfit',
      label: 'Studio Outfit',
      description: '(basic plain sweater)',
      image: clothingImage('mix-button_2.2.png')
    },
    {
      id: 'own-outfit',
      label: 'Your Own Outfit',
      description: '(based on your photo)',
      image: clothingImage('mix-button_2.1.png')
    }
  ],
  'deep-burgundy': [
    {
      id: 'studio-outfit',
      label: 'Studio Outfit',
      description: '(basic plain sweater)',
      image: clothingImage('mix-button_3.2.png')
    },
    {
      id: 'own-outfit',
      label: 'Your Own Outfit',
      description: '(based on your photo)',
      image: clothingImage('mix-button_3.1.png')
    }
  ],
  'classic-mono': [
    {
      id: 'studio-outfit',
      label: 'Studio Outfit',
      description: '(basic plain sweater)',
      image: clothingImage('mix-button_4.1.png')
    },
    {
      id: 'own-outfit',
      label: 'Your Own Outfit',
      description: '(based on your photo)',
      image: clothingImage('mix-button_4.2.png')
    }
  ]
};

export const clothingOptions = clothingOptionsByMood['warm-beige'];

export const demoImages = [
  { src: sampleAsset('soulpaw-1_Person_Demo_1.jpg'), alt: 'Portrait demo with one person and pets' },
  { src: sampleAsset('soulpaw-1_Person_Demo_2.jpg'), alt: 'Black and white portrait demo with one person and a pet' },
  { src: sampleAsset('soulpaw-1_Person_Demo_3.jpg'), alt: 'Warm portrait demo with one person and a pet' },
  { src: sampleAsset('soulpaw-1_Person_Demo_4.jpg'), alt: 'Ash portrait demo with one person and two pets' },
  { src: sampleAsset('demo-2-people-1-pet.webp'), alt: 'Warm portrait demo with two people and one pet' }
];

export const comparisonImages = [
  sampleAsset('soulpaw-so_sanh_1.jpg'),
  sampleAsset('soulpaw-so_sanh_2.jpg'),
  sampleAsset('soulpaw-so_sanh_3.jpg'),
  sampleAsset('soulpaw-so_sanh_4.jpg')
];

export const previewSampleImage = sampleAsset('soulpaw-preview-sample-watermarked.webp');

export const processingSlides = [
  {
    image: sampleAsset('soulpaw-Feedback_1.jpg'),
    text:
      'You may only share a part of your life with them, but to them, you are their entire world. Every photo becomes more than just a memory - it holds the love, loyalty, and quiet moments they spent loving you their whole life.',
    author: 'Amanda C.'
  },
  {
    image: sampleAsset('soulpaw-Feedback_2.jpg'),
    text:
      'I was genuinely surprised by how real this portrait feels. My dog looks exactly like himself - happy, expressive, and full of personality. It honestly looks like a real professional studio photo.',
    author: 'Natalie H.'
  },
  {
    image: sampleAsset('soulpaw-Feedback_3.jpg'),
    text:
      'We were honestly amazed by how natural and emotional this portrait turned out. The dogs look exactly like themselves, and the warmth between all of us feels so real. It genuinely looks like a professional family studio session.',
    author: 'Claire T.'
  },
  {
    image: sampleAsset('soulpaw-Feedback_4.jpg'),
    text:
      "I can't believe how beautifully they captured all three of my pets in one portrait. Every expression feels so natural and full of personality - it honestly feels like a real family photo.",
    author: 'Rebecca A.'
  },
  {
    image: sampleAsset('soulpaw-Feedback_5.jpg'),
    text:
      'Seeing all three of our dogs together in one portrait felt so special. Every little detail looks natural, and the whole photo feels warm, happy, and genuinely us.',
    author: 'Sophie W.'
  }
];

export const storySlides = [
  {
    image: sampleAsset('mix-story_1.png'),
    text: "I lost my dog last year after 13 wonderful years together. I thought I had enough photos of him, but nothing prepared me for how emotional it would feel seeing us together in a beautifully crafted portrait. Pawbond captured his personality perfectly. I genuinely cried when I opened the final image. This is something I'll treasure forever.",
    caption: 'Portrait of Sophia & Noodle'
  },
  {
    image: sampleAsset('mix-story_2.png'),
    text: 'I ordered a portrait as a birthday gift for my wife, featuring her and our rescue dog. She absolutely loved it. The quality exceeded my expectations, and the whole process was surprisingly easy. It felt much more personal and meaningful than any traditional gift.',
    caption: 'Portrait of Olivia & Maple'
  },
  {
    image: sampleAsset('mix-story_3.png'),
    text: "I'll be honest I was skeptical at first. There are so many AI-generated portrait services online these days. Pawbond stood out because the final artwork actually felt authentic and emotional rather than overly artificial. The attention to detail was impressive, especially in my dog's expression. Highly recommended.",
    caption: 'Portrait of Josephine & Nova'
  },
  {
    image: sampleAsset('mix-story_4.png'),
    text: "As a cat owner, I know how difficult it is to capture a cat's personality in photos. Somehow they managed to create a portrait that looks exactly like my little troublemaker. Every tiny detail felt right. Friends keep asking where I got it done.",
    caption: 'Portrait of Ben & Sunny'
  },
  {
    image: sampleAsset('mix-story_5.png'),
    text: "Just received my portrait today and WOW. I honestly wasn't expecting it to look this good. My dog looks amazing, the details are incredible, and the overall vibe is so warm and elegant. Already thinking about ordering another one for my parents.",
    caption: 'Portrait of Victoria & Archie'
  }
];
